exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-sub-text {\n  font-size: 4vh; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/routes/invalid-ticket/invalid-ticket.component.scss
// module id = ../../../../../src/app/routes/invalid-ticket/invalid-ticket.component.scss
// module chunks = main